import React, { HTMLProps, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from '../Input.module.scss';

export const NumberInput = ({ value, min = 0, max = 999, commit, className, ...props }: Props) => {

    const [localValue, setLocalValue] = useState<string | null>(null);
    const [isValid, setValid] = useState<boolean>(true);

    const reset = () => {
        setLocalValue(value.toString());
        setValid(true);
    };

    useEffect(reset, [value]);

    const onInput = (input: string) => {
        setLocalValue(input);
        const parsed = parseInt(input, 10);
        if (!isNaN(parsed) && parsed >= min && parsed <= max) {
            setValid(true);
            commit(parsed);
        } else {
            setValid(false);
        }
    };

    const classes = classNames(className, {
        [styles.invalid]: !isValid
    });

    return (
        <input
            value={localValue ?? value}
            className={classes}
            onInput={e => onInput(e.currentTarget.value)}
            onBlur={reset}
            {...props} />
    );
};

type Props = HTMLProps<HTMLInputElement> & {
    value: number;
    min?: number;
    max?: number;
    commit: (value: number) => void;
};